module.exports = __webpack_public_path__ + "d74ffcde7138e3b3d7cda2463f3a85a7.svg";